import {
  INSTAGRAM_DM_CHANNEL,
  INSTAGRAM_UI_ID,
  toPersistedChannel,
} from "./connectionChannel";

const OAUTH_STATE_PREFIX = "instagram_auth";

export const INSTAGRAM_DM_OAUTH_SCOPES = [
  "instagram_basic",
  "instagram_manage_messages",
  "pages_manage_metadata",
  "pages_show_list",
  "pages_read_engagement",
  "business_management",
].join(",");

export function getFacebookAppId() {
  const appId = process.env.REACT_APP_FACEBOOK_APP_ID;
  if (!appId) {
    throw new Error("REACT_APP_FACEBOOK_APP_ID no está configurado");
  }
  return appId;
}

export function getFacebookApiVersion() {
  return process.env.REACT_APP_FACEBOOK_API_VERSION || "v23.0";
}

export function getOAuthRedirectUri() {
  return `${window.location.origin}/auth/facebook/callback`;
}

export function buildInstagramOAuthState(whatsappId) {
  if (whatsappId != null && whatsappId !== "") {
    return `${OAUTH_STATE_PREFIX}:${whatsappId}`;
  }
  return OAUTH_STATE_PREFIX;
}

export function parseInstagramOAuthState(state) {
  if (!state || !state.startsWith(OAUTH_STATE_PREFIX)) {
    return null;
  }
  const [, rawId] = state.split(":");
  const whatsappId = rawId ? Number.parseInt(rawId, 10) : undefined;
  return {
    whatsappId: Number.isFinite(whatsappId) ? whatsappId : undefined,
  };
}

export function isValidInstagramOAuthState(state) {
  return Boolean(parseInstagramOAuthState(state));
}

export function buildInstagramConnectPayload({ code, whatsappId, pageId, name }) {
  return {
    ...(code ? { code } : {}),
    ...(whatsappId != null ? { whatsappId } : {}),
    ...(pageId ? { pageId } : {}),
    ...(name ? { name } : {}),
    channel: toPersistedChannel(INSTAGRAM_UI_ID) || INSTAGRAM_DM_CHANNEL,
  };
}

function openOAuthPopup(url) {
  const width = 600;
  const height = 720;
  const left = window.screenX + (window.outerWidth - width) / 2;
  const top = window.screenY + (window.outerHeight - height) / 2;
  const popup = window.open(
    url,
    "instagram_dm_oauth",
    `width=${width},height=${height},left=${left},top=${top},scrollbars=yes`,
  );
  if (!popup) {
    throw new Error("popup_blocked");
  }
  return popup;
}

export function launchInstagramPageOAuth({ whatsappId, pageId } = {}) {
  const appId = getFacebookAppId();
  const version = getFacebookApiVersion();
  const redirectUri = encodeURIComponent(getOAuthRedirectUri());
  const state = encodeURIComponent(buildInstagramOAuthState(whatsappId));
  const scope = encodeURIComponent(INSTAGRAM_DM_OAUTH_SCOPES);
  const url =
    `https://www.facebook.com/${version}/dialog/oauth` +
    `?client_id=${appId}` +
    `&redirect_uri=${redirectUri}` +
    `&state=${state}` +
    `&scope=${scope}` +
    `&response_type=code`;

  return new Promise((resolve, reject) => {
    const popup = openOAuthPopup(url);

    const onMessage = (event) => {
      if (event.origin !== window.location.origin) {
        return;
      }
      const data = event.data;
      if (!data || typeof data !== "object") {
        return;
      }
      if (data.type === "FACEBOOK_AUTH_SUCCESS" && data.flow === "instagram") {
        cleanup();
        resolve(data);
      }
      if (data.type === "FACEBOOK_AUTH_ERROR" && data.flow === "instagram") {
        cleanup();
        reject(new Error(data.errorDescription || data.error || "oauth_failed"));
      }
      if (data.type === "FACEBOOK_AUTH_CANCELED" && data.flow === "instagram") {
        cleanup();
        reject(new Error("signup_canceled"));
      }
    };

    const timer = window.setInterval(() => {
      if (popup.closed) {
        cleanup();
        reject(new Error("signup_canceled"));
      }
    }, 500);

    function cleanup() {
      window.removeEventListener("message", onMessage);
      window.clearInterval(timer);
      if (popup && !popup.closed) {
        popup.close();
      }
    }

    window.addEventListener("message", onMessage);
  });
}
